import { signal } from '@angular/core';
import { TCatalogOption } from '../model';

export const refusedCatalog$$ = signal<TCatalogOption[]>([
  { key: 'כן', value: 1 },
  { key: 'לא', value: 2 },
  { key: 'לא ידוע לי', value: 3 }
]);
